import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  ProductLensTypeList,
  ProductLensTypeListVariables
} from "./types/ProductLensTypeList";

const productLensTypeList = gql`
  query ProductLensTypeList(
    $before: String
    $after: String
    $first: Int
    $last: Int
  ) {
    productLensTypes(
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      totalCount
      edges {
        node {
          id
          name
          extraChargeCode
          prescriptionStartSelect
          skuStartCode
          sortOrder
          isActive
        }
      }
    }
  }
`;
export const useProductLensTypeListQuery = makeQuery<
  ProductLensTypeList,
  ProductLensTypeListVariables
>(productLensTypeList);
